import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/ui/sheet";
import { Button } from "@/ui/button";
import QRCodeModal from "../../../../Core/Components/QRCodeSlider/QRCodeModal";

type Props = {
  show: boolean;
  onClose: () => void;
  singleProfile: any;
  setShowQRModal: (v: boolean) => void;
  title?: string;
};

const QRCodeSheet: React.FC<Props> = ({
  show,
  onClose,
  singleProfile,
  setShowQRModal,
  title = "QR Code",
}) => {
  return (
    <Sheet
      open={show}
      onOpenChange={(open: boolean) => {
        if (!open) onClose();
      }}
    >
      <SheetContent side="right" className="w-full sm:w-[900px] px-4 sm:px-6">
        <div className="flex h-full flex-col">
          <SheetHeader className="shrink-0 px-4 sm:px-6">
            <SheetTitle className="text-base sm:text-lg text-foreground dark:text-white">
              {title}
            </SheetTitle>
          </SheetHeader>

          <div className="flex-1 overflow-auto px-4 sm:px-6 pb-24">
            <div className="mt-3">
              <QRCodeModal
                singleProfile={singleProfile}
                setShowQRModal={setShowQRModal}
              />
            </div>
          </div>

          <div className="shrink-0 border-t border-border bg-popover px-4 sm:px-6 py-3">
            <div className="flex justify-end gap-2">
              <Button type="button" variant="outline" onClick={onClose}>
                Close
              </Button>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default QRCodeSheet;
